import * as React from 'react';
import { Chip as ChipMui } from '@mui/material';
import { ThemeAlert, ThemeTextSize } from '.';
import AppService, { alerttype, textsize } from '../services/app.service';

interface Props {
  id?: string;
  label?: string;
  size?: 'small'|'medium';
  type?: alerttype;
  sx?: any;
}

export const Chip: React.FunctionComponent<Props> = (props) => {
  const isMobile = AppService.isMobile();
  const themeAlert = ThemeAlert(props.type);

  const fontSize = (size?: textsize) => {
    return ThemeTextSize(size || props.size || (isMobile? 'small' : 'extrasmall')).fontSize;
  }
  
  return (
    <>
    {props.label?.trim() &&
    <ChipMui 
      id={props.id}
      label={props.label}
      size={props.size || (isMobile? 'small' : 'small')}
      sx={{bgcolor: themeAlert.bgColor, color: themeAlert.color, fontSize: fontSize(), ...props.sx}}
    />
    }
    </>
  );
}
